module.exports = __webpack_public_path__ + "Flama-Semibold.woff2?359beee04b67a2d1bdb11c9e96e1b6a1";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Semibold.woff2
// module id = 935
// module chunks = 0